import SwapHorizental from "@website/icons/components/swap-horizental";
import Sync from "@website/icons/components/sync";
import { ActionsPropertiesType } from "@website/ui-old/datepicker/components/actions/actions.types";

/**
 * @deprecated please use @website/ui instead
 */
export const useActions = (properties: ActionsPropertiesType) => {
  const { showToday, changeCalendarLocale } = properties;

  return {
    showTodayButtonProperties: {
      onClick: showToday,
      StartIcon: <Sync />,
      color: "secondary" as const,
      size: "small" as const,
      variant: "text" as const
    },
    changeCalendarLocaleButtonProperties: {
      onClick: changeCalendarLocale,
      StartIcon: <SwapHorizental />,
      color: "secondary" as const,
      size: "small" as const,
      variant: "text" as const
    }
  };
};
